<template>
  <v-row class="my-0 mb-5 align-center">
    <v-col cols="12" lg="5" class="py-0 mb-2">
      <div class="d-flex flex-wrap align-center flex">
        <span class="text-body-1 mr-4 text-no-wrap">{{ letterSentDate }}</span>
        <v-tooltip v-if="letter['diagnosFileName']" bottom :allow-overflow="true">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon class='mr-4' @click.prevent="downloadDiagnosis">
              <v-icon size="22">icon-pdf</v-icon>
            </v-btn>
          </template>
          <span>{{ letter['diagnosFileName'] }}</span>
        </v-tooltip>
        <v-tooltip v-if="letter['rentgenFileName']" bottom :allow-overflow="true">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon class='mr-4' @click.prevent="downloadRentgen">
              <v-icon size="22">mdi-folder-zip-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ letter['rentgenFileName'] }}</span>
        </v-tooltip>
      </div>
    </v-col>
    <v-col v-if="isAdmin" cols="12" lg="7" class="py-0 mb-2">
      <div class="d-xl-flex flex-wrap align-center justify-xl-end">
        <div class='flex-grow-1'>
          <v-radio-group hide-details row v-model="messageType" class="my-0 pt-0 mb-4 mb-xl-0">
            <v-radio class="my-2 mr-14" label="e-Boks" :value="0" color="primary"/>
            <v-radio class="my-2 mr-14" label="SMS" :value="1" color="primary"/>
          </v-radio-group>
        </div>
        <div>
          <v-btn class='my-1' depressed :color="sendSmsButtonColor" :loading="sendSmsLoading" :disabled="sendSmsLoading || !letter.rentgenFileName || (isSMS && !visitItem.patientMobilePhone)" @click="sendSms">Send Røntgen til patienten</v-btn>
          <div class="d-flex flex-wrap align-center">
            <v-tooltip v-if="Number.isFinite(letter['patientMessageType'])" bottom :allow-overflow="true">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="20" class="mr-2">{{ smsTypeIcon(letter['patientMessageType']) }}</v-icon>
              </template>
              <span>{{ smsTypeText(letter['patientMessageType']) }}</span>
            </v-tooltip>
            <v-tooltip v-if="Number.isFinite(letter['patientMessageStatus'])" bottom :allow-overflow="true">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="20" :class="['mr-4', logStatusIconColor(letter['patientMessageStatus'])]">{{ logStatusIconName(letter['patientMessageStatus']) }}</v-icon>
              </template>
              <span>{{ logStatusText(letter['patientMessageStatus']) }}</span>
            </v-tooltip>
            <span v-if="Number.isFinite(letter['patientMessageType'])" class="overview-data__note">{{ patientSentDate }}</span>
            <EboksAttachment
              v-for="attachment in (letter['patientEboksMessageAttachments'] || [])"
              :key="`letter-patient-eboks-${letter['letterNumber']}-${attachment['type']}-${attachment['id']}`"
              :visit-id="eboksAttachmentVisitId"
              :attachment-id="attachment['id']"
              :attachment-type="attachment['type']"
            />
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import methods from '../../utils/methods';
  import api from '../../api/api';
  import HeadingBox from '../common/HeadingBox';
  import EboksAttachment from '@/components/common/EboksAttachment.vue';
  import {COMMON_TYPES} from '@/constants/commonTypes';
  import logStatusIconMixin from '@/mixins/logStatusIconMixin';

  export default {
    name: 'OverviewLettersRow',

    components: {HeadingBox, EboksAttachment},
    mixins: [logStatusIconMixin],

    data: function () {
      return {
        sendSmsButtonColor: 'primary',
        sendSmsLoading: false,
        messageType: 0
      };
    },

    props: {
      visitItem: {
        type: Object,
      },
      letter: {
        type: Object,
      },
    },

    computed: {
      isAdmin: function () {
        return this.$store.getters.isAdmin;
      },
      isSMS() {
        return this.messageType === 1;
      },
      captionClasses: function () {
        return [...COMMON_TYPES.CAPTION_CLASSES]
      },
      letterSentDate: function () {
        return this.letter.sendDate ? methods.getSimpleDate(this.letter.sendDate) : 'Afsendelse planlagt..';
      },
      patientSentDate: function () {
        return this.letter.patientMessageStatusDate ? `${methods.getSimpleDate(this.letter.patientMessageStatusDate)}` : 'Ingen dato';
      },
      eboksAttachmentVisitId: function () {
        let id = this.letter['visitId'];
        return id != null ? id : this.visitItem.id;
      },
    },

    methods: {
      downloadDiagnosis: function () {
        methods.downloadURL(api.diagnosisFileUrl(this.visitItem.id, this.letter.letterNumber));
      },
      downloadRentgen: function () {
        methods.downloadURL(api.rentgenFileUrl(this.visitItem.id, this.letter.letterNumber));
      },
      sendSms: async function() {
        try {
          this.sendSmsLoading = true;
          this.sendSmsButtonColor = 'primary';
          await api.sendLetterSmsWithLink(this.visitItem.id, this.letter.letterNumber, {MessageType: this.messageType});
          let newVisit = await api.getVisitInfo(this.visitItem.id);
          this.sendSmsButtonColor = 'success';
          this.sendSmsLoading = false;
          this.$emit('updateVisitItem', newVisit.data);
        } catch (e) {
          this.sendSmsButtonColor = 'error';
          this.sendSmsLoading = false;
        }
      },
      smsTypeIcon: function (type) {
        let names = {
          1: 'mdi-message-text',
          0: 'mdi-alpha-e-box'
        };
        return names[type];
      },
      smsTypeText: function (type) {
        let text = {
          1: 'SMS',
          0: 'e-Boks'
        };
        return text[type];
      },
    },
  };
</script>
